(function ($) {
    $(document).ready(function () {
        childrenSlider();
    });

    // Slick
    function childrenSlider() {
        var wraps = $('.de_block_additional_content_repeater.carousel');
        var slidesNumber = $('.item_wrap').length
        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this).find('.children_section');
                var slider = wrap.find('.children_previews .wrap.carousel .inner_wrapper');
                if (slidesNumber > 1) {
                    slider.parent().prepend('<div class="carousel_arrows"><a class="arrow hidden-xs prev" href="javascript:;">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></a><a class="arrow hidden-xs next" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></a></div>');
                    slider.parent().append('<div class="pager"></div>');
                }
                if (slider.length > 0) {
                    slider.on("init", function () {
                        lazyLoadInstance.update();
                    });
                    slider.slick({
                        rtl: rtl,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        nextArrow: wrap.parent().find('.next'),
                        prevArrow: wrap.parent().find('.prev'),
                        centerMode: true,
                        centerPadding: '0px',
                        fade: true,
                        speed: 1000,
                        arrows: true,
                        dots: true,
                        appendDots: wrap.parent().find('.pager'),
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    arrows: false,
                                }
                            },
                        ]
                    });
                }


            })
        }
    }

}(jQuery));